export default __webpack_public_path__ + "static/media/customise-reporting-icon.7bfd1e56.svg";